export const BATHROOM = "BATHROOM";